
import api from "@/api";



export const getindication = (devComponentId,describe,algorithminfo) => {
    return api.axss("get", `/ocm-gdb/failure/analyse/indication?devComponentId=${devComponentId}&describe=${describe}&algorithminfo=${algorithminfo}`)
  }


export const alarming = (id) => {
  return api.axss("get", `/ocm-oil-site/oil-alarm/oilSiteApplication/alarming?oilSiteId=${id}`)
}



  //通过id置换信息
  export const setbyId = (id,name) => {
    return api.axss("get", `/ocm-gdb/failure/analyse/indication/byId?id=${id}&describe=${name}`)
  }

    //上传部分信息
    export const getIndicatorInfo = (data) => {
      return api.axss("post", `/ocm-gdb/alarming/getIndicatorInfo`,data)
    }


